import script from "./SplitCollections.vue?vue&type=script&setup=true&lang=js"
export * from "./SplitCollections.vue?vue&type=script&setup=true&lang=js"

import "./SplitCollections.vue?vue&type=style&index=0&id=79ae25a0&lang=scss&scoped=true"
script.__scopeId = "data-v-79ae25a0"

export default script